import {
	useMutation,
	useQueryClient,
	type UseMutationOptions,
} from '@tanstack/react-query';
import {
	setAttributeVocabularyValuesOrder,
	// setAttributeVocabularyValuesOrderEndpoint,
	type QueryError,
	type SetAttributeVocabularyValuesOrderResult,
	type SetAttributeVocabularyValuesOrderRequestOptions,
} from '../setAttributeVocabularyValuesOrder';
import {splitEventHandler} from '@netx/core-next/utils';
import {GetAttributeVocabularyValuesReactQueryKey} from './useReactQueryGetAttributeVocabularyValues';
export * from '../setAttributeVocabularyValuesOrder';

export type SetAttributeVocabularyValuesOrderQueryOptions = Omit<
	UseMutationOptions<
		SetAttributeVocabularyValuesOrderResult,
		QueryError,
		SetAttributeVocabularyValuesOrderRequestOptions,
		SetAttributeVocabularyValuesOrderResult
	>,
	'mutationFn'
> & {
	mutationFn?: typeof setAttributeVocabularyValuesOrder;
};

/**
 * react-query wrapper for `setAttributeVocabularyValuesOrder`
 * @param queryKeyParams
 * @param options
 */
export const useReactQuerySetAttributeVocabularyValuesOrder = ({
	mutationFn = setAttributeVocabularyValuesOrder,
	...options
}: SetAttributeVocabularyValuesOrderQueryOptions = {}) => {
	const queryClient = useQueryClient();

	return useMutation<
		SetAttributeVocabularyValuesOrderResult,
		QueryError,
		SetAttributeVocabularyValuesOrderRequestOptions,
		SetAttributeVocabularyValuesOrderResult
	>({
		mutationFn,
		...options,
		onSuccess: splitEventHandler(options.onSuccess, (result, variables) => {
			// queryClient.invalidateQueries({
			// 	queryKey: [
			// 		GetAttributeVocabularyValuesReactQueryKey,
			// 		{id: variables.vocabularyId},
			// 	],
			// });
		}),
	});
};

export default useReactQuerySetAttributeVocabularyValuesOrder;
